import { map } from 'rxjs/operators';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NotificationsService } from 'web-common/src/app/notifications.service';
import { InviteService } from '../services/inviteusers.service';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-admin-invite',
    templateUrl: './admin-invite.component.html',
    styleUrls: ['./admin-invite.component.less'],
    standalone: false
})

export class AdminInviteComponent implements OnInit {
  message1: string = 'Good News!\n' +
    '\n' +
    '    You are invited to use EndNote Fusion.\n' +
    '\n' +
    '    EndNote Fusion is a completely new way of working with articles, papers \n' +
    '    and references, and collaborating on research. It\'s simple to \n' +
    '    use and it will save you a lot of time.';
  message2: string = 'Kind regards,\n' +
    '\n' +
    'The EndNote Fusion Team';
  email_list: string;
  inviteStatusBox = {
    message: '',
    status: ''
  };
  file: any;
  fileName: string;
  emailMSG1: string = this.message1;
  emailMSG2: string = this.message2;
  @ViewChild('emailMSG1DOM', { static: true }) emailMSG1DOM: ElementRef;
  @ViewChild('emailMSG2DOM', { static: true }) emailMSG2DOM: ElementRef;

  constructor(
    private title: Title,
    private inviteService: InviteService,
    private notificationService: NotificationsService
  ) {
    this.title.setTitle(($localize`Invite Users`) + ' - EndNote Fusion');
  }

  fileChange(event) {
    // ms edge specific
    //const eventObj: MSInputMethodContext = <MSInputMethodContext> event;
    const eventObj: any = <any> event;
    const target: HTMLInputElement = <HTMLInputElement> eventObj.target;
    const files: FileList = target.files;
    const file = files[0];
    if (this.hasValidExtension(file.name)) {
      this.file = file;
      this.inviteStatusBox.message = '';
      this.inviteStatusBox.status = '';
    } else {
      this.inviteStatusBox.message = 'This file type is not supported.';
      this.inviteStatusBox.status = 'error';
      this.file = null;
    }
  }

  onSubmit(form) {
    this.getEmailMsg1FromDOM();
    this.getEmailMsg2FromDOM();
    this.inviteStatusBox.message = '';
    this.inviteStatusBox.status = '';
    if (!this.email_list && !this.file) {
      this.inviteStatusBox.message = 'Your list contained no valid emails or all email addresses already have an account.' +
        ' Please check the list and try again.';
      this.inviteStatusBox.status = 'error';
    } else {
      this.inviteService.InviteUsers(
        this.email_list,
        this.file,
        this.emailMSG1,
        this.emailMSG2
      ).pipe(map(res => res)).subscribe(this.showInviteResponse, this.showError);
    }
  }

  showInviteResponse = res => {
    this.inviteStatusBox = {
      message: (res.status === 'success' ? res.data.message : res.message),
      status: res.status
    };

    this.email_list = '';
    this.fileName = '';
    this.emailMSG1 = this.message1;
    this.emailMSG2 = this.message2;
  }

  private showError() {
    this.notificationService.error('There was an error sending the invitations', 'Error');
  }
  onTextarea1Change(ev) {
    try {
      this.emailMSG1 = ev.target.value;
    } catch (e) {
      console.log('could not set textarea-value');
    }
  }
  onTextarea2Change(ev) {
    try {
      this.emailMSG2 = ev.target.value;
    } catch (e) {
      console.log('could not set textarea-value');
    }
  }

  getEmailMsg1FromDOM() {
    try {
      this.emailMSG1 = this.emailMSG1DOM.nativeElement.value;
    } catch (e) {
      console.log('could not get textarea-value');
    }
  }

  getEmailMsg2FromDOM() {
    try {
      this.emailMSG2 = this.emailMSG2DOM.nativeElement.value;
    } catch (e) {
      console.log('could not get textarea-value');
    }
  }

  hasValidExtension(fileName) {
    if (fileName === null || fileName === '') {
      return false;
    }
    const extension = fileName.split('.').pop();
    if (extension === null || extension === '') {
      return false;
    }
    if (extension.toLowerCase() !== 'txt') {
      return false;
    }
    return true;
  }

  ngOnInit() {
  }
}
